import React from 'react';
import StaticPageTemplate from '../components/ui/StaticPageTemplate';
import PDFLink from '../components/ui/PDFLink';
import styled from 'styled-components';
import { policiesPageQuery } from '../queries';

const Section = styled.section`
  margin-bottom: 3rem;
`;

const SectionTitle = styled.h2`
  color: #2E5984;
  margin-bottom: 1.5rem;
  font-size: 1.8rem;
`;

const PDFGrid = styled.div`
  display: grid;
  gap: 1rem;
  margin-top: 1.5rem;
`;

const Policies = () => {
  console.log("Policies component rendered");

  const defaultData = {
    title: "Policies",
    subtitle: "Our policies and procedures",
    introText:
      "Tandara has a comprehensive system of policies and procedures it is required by the Federal Government to publish some of these."
  };

  const customContent = (pageData) => {
    console.log("Policies customContent pageData:", pageData);

    return (
      <Section>
        <SectionTitle>Policy Documents</SectionTitle>
          {pageData?.policies?.length > 0 ? (
            <PDFGrid>
              {pageData.policies.map((policy, index) => (
                <PDFLink
                  key={policy._key || index}
                  title={policy.policyTitle}
                  description="Policy document"
                  pdfUrl={policy.documentUrl}
                />
              ))}
            </PDFGrid>
          ) : (
          <PDFGrid>
            <PDFLink
              title="Open Disclosure Policy"
              description="Our commitment to transparency and open communication"
              pdfUrl="/src/assets/pdfs/Tandara_Open_Disclosure_Policy.pdf"
            />
            <PDFLink
              title="Alcohol Policy"
              description="Guidelines and procedures regarding alcohol use"
              pdfUrl="/src/assets/pdfs/Alcohol_2021.pdf"
            />
            <PDFLink
              title="Illicit Drug Use Policy"
              description="Policies and procedures regarding illicit drug use"
              pdfUrl="/src/assets/pdfs/Illict_Drug_Use.pdf"
            />
          </PDFGrid>
        )}
      </Section>
    );
  };

  return (
    <StaticPageTemplate
      pageName="policiesPage"
      query={policiesPageQuery}
      defaultData={defaultData}
      customContent={customContent}
    />
  );
};

export default Policies;